import axios from 'axios';

const service = {
    login: async(body) => {
        let uri = '/users/login';
        let url = process.env.REACT_APP_API_URL + uri;

        let config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const consume = await axios.post(`${url}`, body, config)
        // const consume = await axios.post(`${uri}`, body, config)
        return consume
    },
    getCaptcha: async() => {
        let uri = '/getCaptcha';
        let url = process.env.REACT_APP_API_URL + uri;

        const consume = await axios.get(`${url}`)
        return consume
    },
    logout: async() => {
        let uri = '/users/logout';
        let url = process.env.REACT_APP_API_URL + uri;
        let token = localStorage.getItem('token') || '';

        window.localStorage.removeItem('token');
        window.localStorage.removeItem('id_user');
        window.localStorage.removeItem('tahap');

        await axios.get(`${url}`, {
            headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
            }
        })

    }
}

export default service